import { mapGetters, mapMutations } from 'vuex';
import { planTypes, AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES } from '@/common/constants';
import { AddOrRemoveBasePlanActionTypes } from '../constants';
import { getPlanTotalLicenseFilteredFreeTrial } from '@/common/service/validate';

export default {
  data() {
    return {
      title: '',
      msgInstance: null,
      visibleCapacityList: [],
      hasModifyCapacity: false,
    };
  },
  computed: {
    ...mapGetters([
      // 'getCurrentMeetingPlans', DO NOT use getCurrentMeetingPlans because the free trial plan be filtered in bought-plan-filter.js
      'getBoughtMeetingPlans',
      'getCurrentBasePlanInfo',
      'getSelectedPlans',
      'boughtPlans',
      'basicConfig',
    ]),
    currentBasePlans() {
      /* [getBoughtMeetingPlans]  could be =>
        [
            {
                "type": "zoom_meeting",
                "category": "pro",
                "parent_category": "PRO",
                "plan_code": "zo_pro_monthly",
                "plan_type": 1096,
                "cartInfo": {
                    "selected_number": 1,
                    "add_time": 1713494257621,
                    "assignedCount": 1,
                    "price": 0,
                    "planExpireTime": "2024-04-25",
                    "planStartTime": "2024-04-18"
                },
                "amount": 0,
                "billing_cycle": "monthly",
                "dependBasePlanTypeList": [],
                "billingCycleDependBasePlanTypeList": [],
                "isOnlineFreeTrial": true,
            }
        ]*/
      return this.getBoughtMeetingPlans;
    },
    mx_getBoughtOrBuyingBasePlans() {
      const {
        category: basePlanCategory,
        billing_cycle: basePlanBillingCycle,
        planNameKey,
        typeNameKey,
        type: basePlanType,
        plan_code: basePlanCode,
        // FREE TRIAL flag
        isOnlineFreeTrial,
      } = this.currentBasePlans[0];
      const basePlanName = this.$t(planNameKey) || this.$t(typeNameKey);
      // PRO free trial - calc currentBasePlanQuantity need to filtered the pro free trial
      const currentBasePlanQuantity = this.currentBasePlans[0]
        ? getPlanTotalLicenseFilteredFreeTrial(this.currentBasePlans)
        : 0;
      return {
        basePlanCategory,
        basePlanBillingCycle,
        basePlanType,
        basePlanName,
        basePlanCode,
        planNameKey,
        typeNameKey,
        currentBasePlanQuantity,
        isOnlineFreeTrial,
      };
    },
    mx_planLicenseCount() {
      // could be override by specific requirement
      return this.getSelectedPlans[0]?.cartInfo?.selected_number || 0;
    },
    mx_canAutoAddForFreeTrialUpgrade() {
      const { isOnlineFreeTrial } = this.mx_getBoughtOrBuyingBasePlans;
      const autoAddBasePlans = this.currentBasePlans.filter((plan) =>
        AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES.includes(plan.plan_code),
      );
      return (isOnlineFreeTrial && autoAddBasePlans.length === 1);
    },
  },
  methods: {
    ...mapMutations([
      'updateSelectPlanByCategory',
      'setUpdateBasePlan',
      'addOrRemoveBasePlan',
      'setAddedTrialToPaidBasePlanList'
    ]),
    mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, basePlanNewSelectorNumber) {
      this.updateSelectPlanByCategory({
        category: basePlanCategory,
        billingCycle: basePlanBillingCycle,
        cartInfo: { selected_number: basePlanNewSelectorNumber },
      });
      this.$nextTick(() => {
        this.setUpdateBasePlan({ update: true, from: this.title }); // Ensure the triggering of the watch in ZOOM_MEETING/edit.
      });
    },
    mx_onAddedBasePlan() {
      // no-op
    },
    mx_onRemovedBasePlan() {
      // no-op
    },
  },
  watch: {
    mx_planLicenseCount: {
      immediate: true,
      handler(nv) {
        if (!this.mx_canAutoAddForFreeTrialUpgrade) return;
        const {
          basePlanCategory,
          basePlanBillingCycle,
          basePlanType,
          basePlanName,
          basePlanCode,
          currentBasePlanQuantity,
          isOnlineFreeTrial,
        } = this.mx_getBoughtOrBuyingBasePlans;
        if (nv > currentBasePlanQuantity) {
          if (isOnlineFreeTrial) {
            // FREE TRIAL - padding the paid base plan types
            this.setAddedTrialToPaidBasePlanList([basePlanCode])
          }
          if (!this.getSelectedPlans.map((e) => planTypes[e.type]).includes(planTypes[basePlanType])) {
            this.addOrRemoveBasePlan({
              actionType: AddOrRemoveBasePlanActionTypes.ADD_PAID_BASE_PLAN_FOR_FREE_TRIAL_BASE_PLAN,
              planType: planTypes[basePlanType],
            });
            // If auto replenish selected number to base plan
            this.mx_autoSyncSelectedNumber(basePlanCategory, basePlanBillingCycle, nv);
            this.mx_onAddedBasePlan(basePlanName);
          }
        } else if (nv <= currentBasePlanQuantity && this.getSelectedPlans.map((e) => planTypes[e.type]).includes(planTypes[basePlanType])) {
          this.addOrRemoveBasePlan({
            actionType: AddOrRemoveBasePlanActionTypes.REMOVE_PAID_BASE_PLAN_FOR_FREE_TRIAL_BASE_PLAN,
            planType: planTypes[basePlanType],
          });
          this.mx_onRemovedBasePlan(basePlanName);
        }
      },
    },
  },
};
